import { render } from "./KnowledgeVisualizationModal.vue?vue&type=template&id=052640f2&scoped=true&ts=true"
import script from "./KnowledgeVisualizationModal.vue?vue&type=script&lang=ts"
export * from "./KnowledgeVisualizationModal.vue?vue&type=script&lang=ts"

import "./KnowledgeVisualizationModal.vue?vue&type=style&index=0&id=052640f2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052640f2"],['__file',"src/components/KnowledgeVisualizationModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "052640f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('052640f2', __exports__)) {
    api.reload('052640f2', __exports__)
  }
  
  module.hot.accept("./KnowledgeVisualizationModal.vue?vue&type=template&id=052640f2&scoped=true&ts=true", () => {
    api.rerender('052640f2', render)
  })

}


export default __exports__